import { authenticatedRestClient } from 'helpers/restclient';

const TRANSACTIONS_LEDGER_ENDPOINT = '/api/accounting_payment_records';

export default class TransactionsLedgerService {
	static instance = new TransactionsLedgerService();

	_endpoints = {
		records: TRANSACTIONS_LEDGER_ENDPOINT,
		dealershipOptions: '/api/masters/dealerships',
		userOptions: `${TRANSACTIONS_LEDGER_ENDPOINT}/users`,
		paymentMethodOptions: `${TRANSACTIONS_LEDGER_ENDPOINT}/payment_methods`,
		legacyPaymentMethodOptions: '/api/accouting_payment_records/payment_methods',
	};

	constructor() {
		this.restClient = authenticatedRestClient;
	}

	buildRecordsParams = (query = {}) => {
		const { page = 1, per_page = 25, filters = {}, sorting = {} } = query;

		return {
			page,
			per_page,
			...Object.fromEntries(Object.entries(sorting).filter(([, value]) => Boolean(value))),
			...Object.fromEntries(Object.entries(filters).filter(([, value]) => Boolean(value))),
		};
	};

	getRecords = (query = {}) => {
		return this.restClient.get(this._endpoints.records, this.buildRecordsParams(query));
	};

	getDealershipOptions = (name = '') => {
		return this.restClient.get(this._endpoints.dealershipOptions, {
			...(name ? { name } : {}),
		});
	};

	getUserOptions = (name = '') => {
		return this.restClient.get(this._endpoints.userOptions, {
			...(name ? { name } : {}),
		});
	};

	getPaymentMethodOptions = async () => {
		try {
			return await this.restClient.get(this._endpoints.paymentMethodOptions, {});
		} catch (error) {
			return this.restClient.get(this._endpoints.legacyPaymentMethodOptions, {});
		}
	};

	getFilenameFromDisposition = (contentDisposition) => {
		if (!contentDisposition) return null;

		const encodedMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
		if (encodedMatch?.[1]) {
			return decodeURIComponent(encodedMatch[1]);
		}

		const plainMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
		return plainMatch?.[1] || null;
	};

	exportRecordsCsv = async (query = {}) => {
		if (typeof window === 'undefined') return;

		const response = await this.restClient._axios.request({
			url: this._endpoints.records,
			method: 'GET',
			params: {
				...this.buildRecordsParams(query),
				download: 'csv',
			},
			headers: {
				Accept: 'text/csv',
			},
			responseType: 'blob',
			transformResponse: [(data) => data],
		});

		const fileBlob = response.data;
		const fileName =
			this.getFilenameFromDisposition(response?.headers?.['content-disposition']) || 'transactions_ledger.csv';

		const blobUrl = window.URL.createObjectURL(fileBlob);
		const anchor = document.createElement('a');
		anchor.href = blobUrl;
		anchor.download = fileName;
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
		window.URL.revokeObjectURL(blobUrl);
	};
}
